import api from 'configs/api';
import { IGridSettingsResponse } from 'interfaces/Grid';
import { IRequestResponse } from 'interfaces/RequestResponse';

const endpointUrl = 'auth/user/grid';

export const getGridConfiguration = async qsparams => {
  const url = `${endpointUrl}/configuration?${qsparams}`;
  const data = await api.get<IGridSettingsResponse>(url);
  return data;
};

export const postGridConfiguration = async params => {
  const url = `${endpointUrl}/configuration`;
  const { data } = await api.post<IRequestResponse<IGridSettingsResponse>>(
    url,
    params,
  );
  return data;
};

// export const getLastUpdate = async () => {
//   const url = 'planning/lastupdate';
//   const data = await api.get(url);
//   return data;
// };
